import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { VendorForm } from "@/routes/_layout/approved-vendors/-components/form/vendor-form"

export const Route = createFileRoute("/_layout/approved-vendors_/new")({
  staticData: {
    breadcrumb: [
      { label: "Approved vendors", href: "/approved-vendors" },
      { label: "New vendor" },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "approved_vendor:create", "/"),
  component: NewVendorPage,
})

function NewVendorPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () => navigate({ to: "/approved-vendors", search: true })

  return (
    <div className="h-full overflow-y-auto">
      <PageContent>
        <PageTitle title="New vendor" />
        <Card className="p-4 shadow-none">
          <VendorForm
            onSaved={(created) => {
              showToast("Created", `${created.name} added.`, "success")
              close()
            }}
            onCancel={close}
          />
        </Card>
      </PageContent>
    </div>
  )
}
